import { render } from "./HeroiconsOutlineCash.vue?vue&type=template&id=5a33dd10"
const script = {}

import exportComponent from "C:\\laragon\\www\\idmex-api\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCash.vue"]])

export default __exports__